const BASE_URL = "https://api.shubhamraj01.in";

const getHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ── Restaurant ──────────────────────────────────────────
export const getMyRestaurant = async () => {
  const res = await fetch(`${BASE_URL}/api/admin/restaurants/user`, {
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Restaurant nahi mila");
  return res.json();
};

export const createRestaurant = async (data) => {
  const res = await fetch(`${BASE_URL}/api/admin/restaurants`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.message || "Restaurant create failed");
  }
  return res.json();
};

export const updateRestaurant = async (id, data) => {
  const res = await fetch(`${BASE_URL}/api/admin/restaurants/${id}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Restaurant update failed");
  return res.json();
};

export const toggleRestaurantStatus = async (id) => {
  const res = await fetch(`${BASE_URL}/api/admin/restaurants/${id}/status`, {
    method: "PUT",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Status update failed");
  return res.json();
};

// ── Food ────────────────────────────────────────────────
export const getRestaurantFoods = async (restaurantId) => {
  const res = await fetch(
    `${BASE_URL}/api/food/restaurant/${restaurantId}?vegetarian=false&seasonal=false&nonveg=false`,
    { headers: getHeaders() }
  );
  if (!res.ok) throw new Error("Foods nahi mile");
  return res.json();
};

// ── Orders ──────────────────────────────────────────────
export const getRestaurantOrders = async (restaurantId) => {
  const res = await fetch(
    `${BASE_URL}/api/admin/order/restaurant/${restaurantId}`,
    { headers: getHeaders() }
  );
  if (!res.ok) throw new Error("Orders nahi mile");
  return res.json();
};

export const updateOrderStatus = async (orderId, status) => {
  const res = await fetch(
    `${BASE_URL}/api/admin/order/${orderId}/${status}`,
    { method: "GET", headers: getHeaders() }
  );
  if (!res.ok) throw new Error("Order update failed");
  return res.json();
};